<template>
    <div class="page-homes">
        <CBNavbar @navbar-click="onNavbarClick" />
        <div class="page">
            <div class="pageContentOne">
                <div class="pageContentOne1">社区邀请</div>
            </div>
            <div class="CommunityInvitation_register">
                <el-input class="CommunityInvitation_input1" v-model="input" placeholder="输入邀请人地址" :disabled="inputJudge"></el-input>
                <div class="register">注册</div>
            </div>
            <div class="pageContentTwentyOne">
                <div class="pageContentTwentyOne1_nine">
                    <div style="display: flex;align-items: center;">
                        <img src="@/assets/images/9.png" alt="nine" class="nine"/>
                        <div class="pageContentTwentyOne1">社区信息</div>
                    </div>
                    <img src="@/assets/images/10.png" alt="ten" class="ten"/>
                </div>
                <div class="CommunityInvitation_underline"></div>
                <div class="pageContentTens">
                    <div class="pageContentTen1">{{$t('value97')}}</div>
                    <div class="pageContentTen2">1123.32 FLOW</div>
                </div>
                <div class="pageContentEleven">
                    <div>{{$t('value98')}}</div>
                    <div>1123.32 FLOW{{$t('FLOWPrice')}}</div>
                </div>
                <div class="pageContentEleven">
                    <div>{{$t('value99')}}</div>
                    <div>1000000.00 FLOW</div>
                </div>
                <div class="pageContentTwelve">
                    <div>{{$t('value58')}}</div>
                    <div>1230.32 FLOW</div>
                </div>
            </div>
            <div class="CommunityInvitation_invite">
                <div class="CommunityInvitation_getSon">
                    <img src="@/assets/images/12.png" alt="twelve" class="twelve"/>
                    <div class="pageContentNine">{{$t('value70')}}</div>
                </div>
                <div class="site">0x31731EC8B81AC194D8074532a045D5184887755D</div>
                <div class="pageContentFourteen">
                    <div class="pageContentFourteen1">{{ $t('value1120') }}</div>
                    <div class="pageContentFourteen2" @click="drawer=true">{{ $t('value103') }}</div>
                </div>
            </div>
            <div class="CommunityInvitation_get">
                <div class="CommunityInvitation_getSon">
                    <img src="@/assets/images/11.png" alt="eleven" class="eleven"/>
                    <div class="pageContentNine">{{$t('value70')}}</div>
                </div>
                <div class="pageContentTenss">
                    <div class="pageContentTen1">{{$t('value57')}}</div>
                    <div class="pageContentTen2">{{ datas.SQClaimableEarnings }} FLOW</div>
                </div>
                <div class="pageContentTenss">
                    <div>{{$t('value58')}}</div>
                    <div>{{datas.SQReceivedEarnings}} FLOW</div>
                </div>
                <div class="pageContentEight" @click="claimFnTriggter">{{$t('value61')}}</div>
                <!-- <div class="pageContentEights">{{$t('value61')}}</div> -->
            </div>
        </div>
    </div>
</template>

<script>
import CBNavbar from '@/components/navbar/indexTwo.vue'
import { mapState, mapGetters } from 'vuex'
// import { MessageBox } from 'element-ui';
import { userLevelFn, datas, getUnDistributeRewardAmountFn, userEarnedFn, userClaimedFn, claimFn, getLevelUserCountFn } from "@/web3/index.js"
// import { userLevelFn, datas, userEarnedFn, userClaimedFn, claimFn, getLevelUserCountFn } from "@/web3/index.js"
import './CommunityInvitation.css'
import { locationHrefIndex } from '@/web3/index'
export default {
    name: 'CommissionDividend',
    components: {
        CBNavbar,
    },
    data() {
        return {
          imgTwoList:[
            { 
                url: require('@/assets/images/card.png'),
                OutputRatio:'1.2',
                TotalTokenOutput:'1000',
            },
            { 
                url: require('@/assets/images/card2.png'),
                OutputRatio:'1.2',
                TotalTokenOutput:'4000', 
            },
            { 
                url: require('@/assets/images/card3.png'),
                OutputRatio:'1.3',
                TotalTokenOutput:'15000',
            },
            { 
                url: require('@/assets/images/card4.png'),
                OutputRatio:'1.4',
                TotalTokenOutput:'50000', 
            },
            { 
                url: require('@/assets/images/card5.png'),
                OutputRatio:'1.5',
                TotalTokenOutput:'20000', 
            },
          ],
          imgTwoListData: { 
                url: require('@/assets/images/card.png'),
                OutputRatio:'1.2',
                TotalTokenOutput:'1000',
          },
          drawer: false,
          direction: 'btt',
          datas,
          v1Num:"--",
          v2Num:'--',
          v3Num:'--',
          v4Num:'--',
          v5Num:'--',
          offTimer:null,
        }
    },
    computed: {
        ...mapState(['address']),
        ...mapGetters(['isLogin']),
    },
    methods: {
      onNavbarClick(value) {
        console.log('Navbar clicked with value:', value); // 处理事件的方法，接收传递的值
        this.$router.push('/')
        // 在这里可以执行其他逻辑
      },
      prevFn(val,content){
        console.log('上一个',val,content);
        this.imgTwoListData=this.imgTwoList[val]
        console.log('获取data',this.imgTwoListData);
      },
      claimFnTriggter(){
        if(this.datas.SQClaimableEarnings==0){
            this.$message(this.$t('value78'))
            return
        }
        claimFn(this)
      },
      upData(){
        setTimeout(async ()=>{
            userLevelFn(this)
            getUnDistributeRewardAmountFn()
            userEarnedFn(this)
            userClaimedFn(this)
            
            this.v1Num=await getLevelUserCountFn(1)
            this.v2Num=await getLevelUserCountFn(2)
            console.log('打印等级对应的用户',this.v2Num);
            this.v3Num=await getLevelUserCountFn(3)
            this.v4Num=await getLevelUserCountFn(4)
            this.v5Num=await getLevelUserCountFn(5)
        },1500)
      },
    },
    watch: {
        address(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.upData();
            }
        }
    },
    mounted(){
        this.upData()
        this.offTimer=setInterval(async ()=>{
            let value=await locationHrefIndex()
            if(value){
            clearInterval(this.offTimer);  
            this.offTimer=null
            }
        },1000)
    },
    //离开页面时执行函数
    beforeDestroy() {         
        clearInterval(this.offTimer);  
        this.offTimer=null
    },
}
</script>
<style scoped lang="less">

</style>
